import { Row } from '@tanstack/react-table';
import { UpstreamEvent } from 'client';

import { CustomerStatusField } from '../customer-status-field';

type Props = {
  row: Row<UpstreamEvent>;
};

export function CustomerStatusCell({ row }: Props) {
  return (
    <CustomerStatusField
      eventId={row.original.event_id}
      status={row.original.customer_status}
      display={row.original.customer_status_display}
    />
  );
}
